export const NEXT_RUNTIME = process.env.NEXT_RUNTIME;
export const IS_NEXT_EDGE_RUNTIME = NEXT_RUNTIME === 'edge';
